import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';
import {
	createDirectionKey,
	type Direction,
	type DirectionKey,
} from '../model/direction.schema';
import { graphHopperDirectionQueryOption } from './direction.options';
import type { RouteSummary } from './routeSummary.schema';

const useDirectionDistances = (
	directions: Direction[],
): Map<DirectionKey, number> => {
	const results = useQueries({
		queries: directions.map((direction) =>
			graphHopperDirectionQueryOption(
				`${direction.originId}-${direction.destinationId}`,
				direction.origin,
				direction.destination,
			),
		),
	});

	return useMemo(
		() =>
			new Map(
				results
					.map((result, i) => {
						const key = createDirectionKey(
							directions[i].originId,
							directions[i].destinationId,
						);

						return [key, result.data?.distance] as const;
					})
					.filter(
						(entry): entry is [DirectionKey, RouteSummary['distance']] =>
							entry[0] != null && entry[1] != null,
					),
			),
		[directions, results],
	);
};

export default useDirectionDistances;
